import React from 'react';
import wb0 from '../img/Detail/lon-detail.jpg';
import './Detail.css';
const GameDetail = () => {
  return (
    <div className="image-detail-container">
      <img src={wb0} alt="Kuş" />
    </div>
    
  );
};

export default GameDetail;